import { useCallback } from "react";
import { Column, Link, Row } from "@react-email/components";
import { t } from "@/i18n-js/instance";
import { defaultStyles } from "./defaultStyles";

export const PreferenceSection = ({
  isPreviewMode,
}: {
  isPreviewMode: boolean;
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (isPreviewMode) event.preventDefault();
    },
    [isPreviewMode],
  );

  return (
    <Row style={defaultStyles.preferencesRow}>
      <Column align="center">
        <span>
          {t("settings.emails.settings.update_your")}
          <Link
            style={defaultStyles.link}
            href="{{email_footer_manage_preferences_url}}"
            onClick={handleClick}
          >
            {t("settings.emails.settings.email_preferences")}
          </Link>
          {t("settings.emails.settings.or")}
          <Link
            style={defaultStyles.link}
            href="{{email_footer_manage_preferences_url}}"
            onClick={handleClick}
          >
            {t("settings.emails.settings.unsubscribe")}
          </Link>
        </span>
      </Column>
    </Row>
  );
};
